import {useState, useEffect} from 'react';
import {ORGANIZATION_TYPES} from '../utils/constants';
import {identifyClientType} from '../../../utils/identifyClientType';
import {getClientConfig} from '../../../config/clientThemes';

export const useOrganization = () => {
  const [organization, setOrganization] = useState({
    type: ORGANIZATION_TYPES.DEFAULT,
    config: null,
    flags: {
      isAtpl: false,
      isHelloHealth: false,
      isDoktor: false,
      isDefault: true,
    },
  });

  useEffect(() => {
    // Get organization type
    const clientType = identifyClientType();

    // Get flags from localStorage
    const isAtpl = window.localStorage.getItem('from_atp') === 'true';
    const isHelloHealth = window.localStorage.getItem('from_hellohealth') === 'true';
    const isDoktor = window.localStorage.getItem('from_doktor') === 'true';

    // Determine organization type
    let orgType = ORGANIZATION_TYPES.DEFAULT;
    if (isAtpl) {
      orgType = ORGANIZATION_TYPES.ATPL;
    } else if (isHelloHealth) {
      orgType = ORGANIZATION_TYPES.HELLO_HEALTH;
    } else if (isDoktor) {
      orgType = ORGANIZATION_TYPES.DOKTOR_CONNECT;
    }

    // Get configuration
    const config = getClientConfig(clientType);

    setOrganization({
      type: orgType,
      config,
      flags: {
        isAtpl,
        isHelloHealth,
        isDoktor,
        isDefault: orgType === ORGANIZATION_TYPES.DEFAULT,
      },
    });
  }, []);

  return organization;
};

import {useMemo} from 'react';
import {HEALTH_CATEGORIES} from '../utils/constants';

export const useOrganizationFeatures = organizationType => {
  return useMemo(() => {
    const features = {
      showSkinHealth: false,
      showProducts: false,
      showLabTests: false,
      showSymptomChecker: true,
      showShareButtons: true,
      showUpgradeOption: false,
      useExternalNavigation: false,
      customBackButton: false,
      blurCategories: [],
      availableCategories: [],
    };

    switch (organizationType) {
      case ORGANIZATION_TYPES.DEFAULT:
        features.showSkinHealth = true;
        features.showProducts = true;
        features.showUpgradeOption = true;
        features.blurCategories = [
          HEALTH_CATEGORIES.PHYSICAL,
          HEALTH_CATEGORIES.SKIN,
          HEALTH_CATEGORIES.DISEASE_RISK,
          HEALTH_CATEGORIES.METABOLIC,
        ];
        features.availableCategories = [
          HEALTH_CATEGORIES.HEART,
          HEALTH_CATEGORIES.BODY_FUNCTION,
          HEALTH_CATEGORIES.PHYSICAL,
          HEALTH_CATEGORIES.SKIN,
          HEALTH_CATEGORIES.DISEASE_RISK,
          HEALTH_CATEGORIES.METABOLIC,
          HEALTH_CATEGORIES.PRODUCTS,
        ];
        break;

      case ORGANIZATION_TYPES.ATPL:
        features.showProducts = true;
        features.customBackButton = true;
        features.availableCategories = [
          HEALTH_CATEGORIES.OVERALL,
          HEALTH_CATEGORIES.HEART,
          HEALTH_CATEGORIES.BODY_FUNCTION,
          HEALTH_CATEGORIES.PHYSICAL,
          HEALTH_CATEGORIES.DISEASE_RISK,
          HEALTH_CATEGORIES.METABOLIC,
          HEALTH_CATEGORIES.PRODUCTS,
        ];
        break;

      case ORGANIZATION_TYPES.HELLO_HEALTH:
        features.showProducts = true;
        features.showLabTests = true;
        features.useExternalNavigation = true;
        features.availableCategories = [
          HEALTH_CATEGORIES.HEART,
          HEALTH_CATEGORIES.BODY_FUNCTION,
          HEALTH_CATEGORIES.PHYSICAL,
          HEALTH_CATEGORIES.DISEASE_RISK,
          HEALTH_CATEGORIES.METABOLIC,
          HEALTH_CATEGORIES.PRODUCTS,
          HEALTH_CATEGORIES.LAB_TESTS,
        ];
        break;

      case ORGANIZATION_TYPES.DOKTOR_CONNECT:
        features.showShareButtons = false;
        features.blurCategories = [
          HEALTH_CATEGORIES.PHYSICAL,
          HEALTH_CATEGORIES.DISEASE_RISK,
          HEALTH_CATEGORIES.METABOLIC,
        ];
        features.availableCategories = [
          HEALTH_CATEGORIES.HEART,
          HEALTH_CATEGORIES.BODY_FUNCTION,
          HEALTH_CATEGORIES.PHYSICAL,
          HEALTH_CATEGORIES.DISEASE_RISK,
          HEALTH_CATEGORIES.METABOLIC,
        ];
        break;
    }

    return features;
  }, [organizationType]);
};
